module.exports = __webpack_public_path__ + "img/app-store-badge.31090efd.png";